import React, { useState } from 'react';
import TextBox from 'devextreme-react/text-box';
import Button from 'devextreme-react/button';
import CheckBox from 'devextreme-react/check-box';
import { getUserTokenRequest, loginFromMobiserver } from '../../api/request';
import {
  setUserToken,
  setAppToken,
  setUserRef,
  setUserName as setSessionUserName,
} from '../../api/session';
import notify from 'devextreme/ui/notify';
import { useTranslation } from 'react-i18next';
import { AppFooter } from '../../components/library/app-footer/AppFooter';
import { CardAuth } from '../../components/library/card-auth/CardAuth';
import loginBg from '../../assets/loginform.avif';
import logo from '../../assets/logo.png';
import foresLogo from '../../assets/product/fores.png';
import pMobiAdmin from '../../assets/product/mobiAdmin.png';
import pMobiOffice from '../../assets/product/mobiOffice.png';
import pMobiRoute from '../../assets/product/mobiRoute.png';
import pMobiSupport from '../../assets/product/mobiSupport.png';
import pMobiShop from '../../assets/product/mobiShop.png';
import pMobiSales from '../../assets/product/mobiSales.png';
import pMobiPack from '../../assets/product/mobiPack.png';
import './LoginPage.scss';

export const LoginPage = () => {
  const { t } = useTranslation();

  const [mobiUserName, setMobiUserName] = useState('');
  const [mobiPassword, setMobiPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!mobiUserName || !mobiPassword) {
      notify(t('usernameAndPasswordRequired'), 'warning', 2000);
      return;
    }

    setLoading(true);
    try {
      // Adim 1: userToken al (serviceId 9990)
      const tokenRes: any = await getUserTokenRequest(mobiUserName, mobiPassword);
      if (tokenRes?.resCode !== 200 || !tokenRes?.userToken) {
        notify(tokenRes?.resMessage ?? t('loginFailed'), 'error', 3000);
        return;
      }
      setUserToken(String(tokenRes.userToken));

      // Adim 2: login (serviceId 9992)
      const response: any = await loginFromMobiserver();
      if (response?.resCode !== 200) {
        notify(response?.resMessage ?? t('loginFailed'), 'error', 3000);
        return;
      }

      const apiToken = response?.userData?.[0]?.apiToken;
      const userRef = response?.userData?.[0]?.userRef;
      if (!apiToken || userRef === undefined || userRef === null) {
        notify(t('loginFailed'), 'error', 3000);
        return;
      }

      setAppToken(apiToken);
      setUserRef(String(userRef));
      setSessionUserName(mobiUserName);

      notify(t('loginSuccessfull'), 'success', 2000);
      window.location.reload();
    } catch (error: any) {
      notify(error.message || t('loginFailed'), 'error', 3000);
    } finally {
      setLoading(false);
    }
  };

  const stats = [
    { value: '500+', label: t('statCustomers') },
    { value: '12', label: t('statInvoices') },
    { value: '8', label: t('statYearsExperience') },
  ];

  return (
    <div className="login-page-v1">

      <div className="login-hero-v1" style={{ background: `linear-gradient(135deg, #082a4ef2, #0f6cbde0 50%, #041428f7), url(${loginBg}) center/cover no-repeat` }}>

        <div className="hero-decoration-v1">
          <div className="decoration-circle circle-1"></div>
          <div className="decoration-circle circle-2"></div>
          <div className="decoration-circle circle-3"></div>
          <div className="decoration-grid"></div>
        </div>

        {/* Floating Cards */}
        <div className="floating-elements">
          <div className="float-card float-card-1">
            <div className="float-icon success">
              <i className="dx-icon-check"></i>
            </div>
            <div className="float-text">
              <span className="float-title">{t('orderConfirmed')}</span>
              <span className="float-desc">#TKT-1042</span>
            </div>
          </div>
          <div className="float-card float-card-2">
            <div className="float-icon primary">
              <i className="dx-icon-email"></i>
            </div>
            <div className="float-text">
              <span className="float-title">{t('invoiceSent')}</span>
              <span className="float-desc">#TKT-1043</span>
            </div>
          </div>
          <div className="float-card float-card-3">
            <div className="float-icon warning">
              <i className="dx-icon-comment"></i>
            </div>
            <div className="float-text">
              <span className="float-title">{t('newOrder')}</span>
              <span className="float-desc">{t('fiveProducts')}</span>
            </div>
          </div>
        </div>

        <div className="hero-content-v1">

          <div className="hero-logo-top">
            <img src={logo} alt="MobiSupport" className="hero-logo-v1" />
          </div>

          <h1 className="hero-title-v1">
            <span className="line-large">{t('heroTitleLine2')}</span>
          </h1>
          <p className="hero-description-v1">
            {t('heroDescription')}
          </p>

          <div className="hero-stats-v1">
            {stats.map((stat, index) => (
              <div key={index} className="stat-item-v1">
                <span className="stat-value">{stat.value}</span>
                <span className="stat-label">{stat.label}</span>
              </div>
            ))}
          </div>

        </div>

        <div className="hero-products-footer">
          <img src={foresLogo} alt="fores" className="hero-fores-logo" />
          <div className="hero-products-list">
            <img src={pMobiAdmin} alt="mobiAdmin" />
            <img src={pMobiOffice} alt="mobiOffice" />
            <img src={pMobiRoute} alt="mobiRoute" />
            <img src={pMobiSupport} alt="mobiSupport" />
            <img src={pMobiShop} alt="mobiShop" />
            <img src={pMobiSales} alt="mobiSales" />
            <img src={pMobiPack} alt="mobiPack" />
          </div>
        </div>
      </div>

      <div className="login-right-panel">
        <CardAuth>
          <form onSubmit={handleSubmit}>
            <div className="form-field">
              <TextBox
                placeholder={t('userName')}
                value={mobiUserName}
                onValueChanged={(e) => setMobiUserName(e.value)}
                stylingMode="filled"
                height={40}
              />
            </div>
            <div className="form-field">
              <TextBox
                placeholder={t('password')}
                value={mobiPassword}
                onValueChanged={(e) => setMobiPassword(e.value)}
                mode="password"
                stylingMode="filled"
                height={40}
              />
            </div>
            <div className="form-field remember-field">
              <CheckBox
                text={t('rememberMe')}
                value={rememberMe}
                onValueChanged={(e) => setRememberMe(e.value)}
              />
            </div>
            <Button
              text={loading ? t('loggingIn') : t('signIn')}
              type="default"
              stylingMode="contained"
              useSubmitBehavior={true}
              disabled={loading}
              width="100%"
              height={36}
            />
          </form>
        </CardAuth>

        <div className="login-footer-v1">
          <AppFooter />
        </div>
      </div>
    </div>
  );
};
